import React, { useState, useEffect } from 'react';
import style from './QuizTwo.module.sass';
import { Transition, CSSTransition } from 'react-transition-group';

const myQuestions = [
    {
        question: "Will I die after period sex? ",
        answers:[
            "Obvs 👌",
            "No ☝️",
            "Depends 🤞"
        ],
        correctAnswer: 0,
        explanation: "This obvious medical fact has been fully supported by Roman philosopher Pliny the Elder, who wrote in AD 60 that sex with a menstruating woman during a solar eclipse could prove deadly. (JK: It’s totally fine.)",
    },
    {
        question: "Can I stop having periods while on birth control pills? ",
        answers:[
            "Absolutely yes. 🙋‍♀️",
            "No. 🙅‍♂️",
            "I don't know. 🤷‍♀️"
        ],
        correctAnswer: 0,
        explanation: "For decades women have been made to believe that they need an artificial period - a monthly hormone-free interval - while on the pill. Gynaecologist John Rock suggested the break in 1950, in the hope that the Pope would accept the pill. What’s perhaps more troubling than this forced insurance that confirms women as pregnancy machines under patriarchy, is the fact that this myth was only officially debunked in 2019, under UK’s health guidelines.",
    },
    {
        question: "Are periods a personal issue?",
        answers:[
             "Of course. 🍷",
             "No. 🍻",
             "Yes and no. 🧘‍♀️"
        ],
        correctAnswer: 2,
        explanation: "While it is completely fine for individuals to prefer treating their periods as a private matter, the wider social impact of period stigma is far from personal. It is only within the last 60 years that menstruation has begun to be properly understood and 1 in 10 girls in Africa still miss school as a result of period poverty.",

    },
    {
        question: "Can all genders have periods?",
        answers:[
             "Come again? 🤯",
             "Yes. 👾",
             "I don't know. 🧐",
        ],
        correctAnswer: 1,
        explanation: "The direct association between periods and the female reproductive system are undeniable (hence pronouns used on this site). However, it is also important to acknowledge that trans boys and men and non-binary people may have periods.",

    },
    {
        question: "Should there be menstrual leave policy in the workplace?",
        answers:[
             "I think so. 🛀 ",
             "No. 👩‍💻",
             "It's complicated. 👩🏻‍🔬",
        ],
        correctAnswer: 2,
        explanation: "Despite the important acknowledgement that severe period pain does affect one’s wellbeing, many find it a patronising concept to ask for period leave, and feel judged even when they do. Perhaps the solution is not about a targeted policy, but an open and honest attitude in the workplace towards menstrual symptoms, where they could be covered by general wellness policies. ",
    },
]

//Overall parent component
const QuizTwo = (props) => {
    const [showQuiz, setShowQuiz] = useState(false);


    const changeView = () => {
        setShowQuiz(!showQuiz);
        props.playPaperFlip()
    }

    return (
        <>
            <QuizTwoIntro handleClick={changeView} />
        
        <CSSTransition
        in = {showQuiz}
        timeout = {300}
        classNames = "quizSlidesAni"
        unmountOnExit
        >  
            <QuizTwoSlides 
            handleClick={changeView} 
            playPaperFlip = {props.playPaperFlip} 
            playCorrect = {props.playCorrect} 
            playSwitch = {props.playSwitch} 
            />
        </CSSTransition>
            
        </>
    )
}

//Title page
const QuizTwoIntro = (props) => {
    return (
        <div className = {`${style.quizTwoIntro} main`}>
            <div className = {`${style.quizTitleContainer} titleOneText`}>
                
                <div className = {style.strong}>
                Things you always wanted to know about period
                </div>

                <div className = {style.weak}>
                (But were too afraid to ask)
                </div>
                
            </div>
            <div className = {style.enterQuizButtonContainer}>
            <div className = {`${style.enterQuizButton} buttonOne`} onClick = {props.handleClick}>Enter Quiz</div>
            </div>
        </div>
    )
}

//Quiz parent
const QuizTwoSlides = (props) => {

    const numOfQuestions = myQuestions.length

        // Get toggleSlide function to changes targetStamp number
        let [targetStamp, setTargetStamp] = useState(0)

        // Timeline loops
        const toggleSlide = (direction) => {
            props.playPaperFlip()
            if (direction === 'next' && targetStamp < numOfQuestions - 1) {
                setPrevAni(false)
                setInProp(false)
                setTimeout(() => {
                    setTargetStamp(targetStamp + 1)
                    setInProp(true)
                }, duration);
            } else if (direction === 'next' && targetStamp >= numOfQuestions - 1) {
                setPrevAni(false)
                setInProp(false)
                setTimeout(() => {
                    setTargetStamp(0)
                    setInProp(true)
                }, duration);
            } else if (direction === 'prev' && targetStamp > 0) {
                setPrevAni(true)
                setInProp(false)
                setTimeout(() => {
                    setTargetStamp(targetStamp - 1)
                    setInProp(true)
                }, duration);
            } else if (targetStamp <= 0) {
                setPrevAni(true)
                setInProp(false)
                setTimeout(() => {
                    setTargetStamp(numOfQuestions - 1)
                    setInProp(true)
                }, duration);
            }
        }
    
        const [inProp, setInProp] = useState(true);
        const [prevAni, setPrevAni] = useState(false);
        const duration = 300;
    
        const defaultStyle = {
        transition: `transform ${duration}ms ease`,
        transform: 'translateX(0)',
        }
    
       let transitionStyles 
    
        if (prevAni) {
            transitionStyles = {
                entering: { transform: 'translateX(-100%)',opacity: 0,},
                entered:  {  transform: 'translateX(0)'},
                exiting:  {  transform: 'translateX(0)'},
                exited:  {  transform: 'translateX(100%)'},
            }} else {
                transitionStyles = {
                entering: { transform: 'translateX(100%)', opacity: 0,},
                entered:  {  transform: 'translateX(0)'},
                exiting:  {  transform: 'translateX(0)'},
                exited:  {  transform: 'translateX(-100%)'},
                }
            }
    return (
        <>
        <div className = {`${style.quizTwoSlides} main`}>
            <div className = {style.contentContainer}>

            <button className = {`${style.backButton} backButton`} onClick={props.handleClick}>

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 83.523 89.418">
                <g id="Polygon_3" data-name="Polygon 3" transform="matrix(0.017, -1, 1, 0.017, 0, 87.987)">
                    <path d="M 87.16427612304688 81.5 L 0.8357251882553101 81.5 L 44 1.057487845420837 L 87.16427612304688 81.5 Z" stroke="none"/>
                    <path d="M 44 2.114997863769531 L 1.671463012695312 81 L 86.32853698730469 81 L 44 2.114997863769531 M 44 0 L 88 82 L 0 82 L 44 0 Z" stroke="none"/>
                </g>
                </svg>
                
                </button>
                <Transition in={inProp} exit = {false} timeout={duration}>
                    {state => (
                        <div style={{
                            ...defaultStyle,
                            ...transitionStyles[state]
                          }}>
                         <Question 
                         playCorrect = {props.playCorrect} 
                         playSwitch = {props.playSwitch} 
                         question={myQuestions[targetStamp].question} 
                         answers= {myQuestions[targetStamp].answers} 
                         correctAnswer={myQuestions[targetStamp].correctAnswer} 
                         explanation={myQuestions[targetStamp].explanation}/> 
                        </div>
                    )}
                </Transition>
                {/* <Question question={myQuestions[targetStamp].question} answers= {myQuestions[targetStamp].answers} correctAnswer={myQuestions[targetStamp].correctAnswer} explanation={myQuestions[targetStamp].explanation}/>  */}
      
            </div>
         {/* Timeline */}
         <div className={style.timelineContainer}>

         {/* Stamps */}
         <div className={style.timelineStamps}>
             <div className={style.dashedLine}></div>
             {
                 myQuestions.map((stamp, i) => {
                     return (
                         <div onClick = {() => setTargetStamp(i)} className={`${style.stamp} ${i === targetStamp && `stampChecked`} main stamp`}></div>
                     )
                 })
             }
         </div>

         {/* Buttons */}
         <div className={style.timelineButtons}>
             <div className={`${style.prevButton} titleTwo timelineButton`} onClick={() => toggleSlide('prev')}>{`<`}</div>
             <div className={`${style.nextButton} titleTwo timelineButton`} onClick={() => toggleSlide('next')}>{`>`}</div>
         </div>
     </div>
     </div>
     </>
    )
}

//Quiz child
const Question = (props) => {

    const [answers, setAnswers] = useState()
    const [clicked, setClicked] = useState (false)

    //updates when props change, "props.answers" is now "answers" with "answer" objects
    useEffect(() => {

        let data = props.answers.map((answer, i) => {
            return { 
                answerText: answer, 
                isCorrect: i === props.correctAnswer,
            }
        })
        setAnswers(data)
        setClicked(false)
    }, [props])
    
   //add style depending on user answer
    const tellAnswer = (i) => {

    setClicked(true)

    const selector =  document.querySelector(`#quizTwoAnswer${i}`)
    const greenAnswer = document.querySelector(`#quizTwoAnswer${props.correctAnswer}`)
    const explanation = document.querySelector("#explainTwo")

       if(answers[i].isCorrect){
            selector.classList.add(`${"correct-quizTwo"}`)
            explanation.classList.add(`${style.visible}`)
            props.playCorrect()

       } else {
           selector.classList.add(`${"wrong-quizTwo"}`)
           greenAnswer.classList.add(`${"correct-quizTwo"}`)  
           explanation.classList.add(`${style.visible}`)
           props.playSwitch()
        }
   }

    return (
        <div key={props.question} className = {style.quizContainer}>

            
            {/* Quizzis */}
            <div className = {style.testContainer}>
                <h1 className={`${style.question} titleOneText`}>{props.question}</h1> 
                <div className={`${style.answers} storyTwoAnswers`}>
                {answers && answers.map((answer, i) => {
                    return(
                            <div key={i}>
                                <div key={i} className={`${style.answer} paraOneText`}
                                    id={`quizTwoAnswer${i}`}
                                    onClick={!clicked ? () => tellAnswer(i) : null} >
                                     {answer.answerText}
                                    
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

             {/* Explanation */}
             <div className = {style.explanationContainer}>
                <h1 id = "explainTwo" className={`${style.explanation} explanation`}>{props.explanation}</h1>
            </div>

        </div>
             
    )
}


  
export default QuizTwo

//initial way of managing dom content
// const QuizTwo = () => {

//     const [showQuiz, setShowQuiz] = useState(false)
//     const changeView = () => {setShowQuiz(!showQuiz)}

//     return (
//         <>
//             {showQuiz ?
//                 <QuizTwoSlides handleClick={changeView} />
//                 :
//                 <QuizTwoIntro
//                     handleClick={changeView}
//                 />
//             }
//         </>
//     )
// }